import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getLoaderSelector } from '@store/loader';
import { LoaderService } from '@services';
import { usePrevious } from '@hooks';
import { LoaderView } from './loader.view';
import { jsx as _jsx } from "react/jsx-runtime";

var Loader = function Loader() {
  var _useSelector = useSelector(getLoaderSelector),
      requestCounter = _useSelector.requestCounter,
      isShowLoader = _useSelector.isShowLoader;

  var dispatch = useDispatch();
  var timeoutCounter = useRef(0);
  var prevCounterState = usePrevious(requestCounter);
  useEffect(function () {
    var timeout;

    if (prevCounterState === 0 && requestCounter > 0) {
      timeout = setTimeout(function () {
        LoaderService.showLoader(dispatch);
        timeout = null;
      }, 100);
    }

    if (prevCounterState && prevCounterState > 0 && requestCounter === 0) {
      if (timeout) {
        clearTimeout(timeout);
      }
    }

    if (prevCounterState !== requestCounter) {
      void Promise.all([new Promise(function (resolve, reject) {
        setTimeout(function () {
          timeoutCounter.current += 1;

          if (prevCounterState && prevCounterState > 0 && requestCounter === 0) {
            timeoutCounter.current -= 1;
            resolve();
          } else {
            timeoutCounter.current -= 1;
            reject(new Error());
          }
        }, 200);
      }), new Promise(function (resolve) {
        if (prevCounterState && prevCounterState > 0 && requestCounter === 0) {
          resolve();
        }
      })]).then(function () {
        if (!timeoutCounter || !requestCounter) {
          LoaderService.hideLoader(dispatch);
        }
      })["catch"](function () {// error
      });
    }
  }, [dispatch, prevCounterState, requestCounter]);
  return /*#__PURE__*/_jsx(LoaderView, {
    isShowLoader: isShowLoader
  });
};

export { Loader };